import { DataStore } from './DataStore';

export default class RootStore {
    public dataStore: DataStore;

    constructor() {
        this.dataStore = new DataStore(this);
    }
}
